
import React from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import {
    faChevronRight
} from "@fortawesome/free-solid-svg-icons";

const OMNISCAN_BLUE = "#20AFE8";
const OMNISCAN_BLUE_RGB = "32, 175, 232";

export default function SlidingDrawer({
    visible,
    width = 420,
    offset = 0,
    zIndex = 10000,
    title = "",
    onClose,
    children
}) {
    return (
        <div
            style={{
                position: "fixed",
                top: 0,

                right: visible
                    ? `${offset}px`
                    : `-${width}px`,

                width,
                height: "100%",

                background:
                    "linear-gradient(155deg, rgba(24,36,49,0.84) 0%, rgba(12,23,36,0.88) 100%)",

                backdropFilter: "blur(24px) saturate(145%)",
                WebkitBackdropFilter: "blur(24px) saturate(145%)",

                borderLeft:
                    `1px solid rgba(${OMNISCAN_BLUE_RGB},0.28)`,

                boxShadow:
                    "-18px 0 55px rgba(0,0,0,0.32), inset 1px 0 0 rgba(255,255,255,0.08)",

                transition:
                    "right 1.45s cubic-bezier(.22,1,.36,1)",

                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                zIndex,

                color: "#fff"
            }}
        >
            {/* HEADER */}
            <div
                style={{
                    minHeight: "64px",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 18px",

                    background:
                        "linear-gradient(90deg, rgba(255,255,255,0.09), rgba(255,255,255,0.025))",

                    borderBottom:
                        "1px solid rgba(255,255,255,0.13)"
                }}
            >
                {onClose && (
                    <div
                        onClick={onClose}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(event) => {
                            if (
                                event.key === "Enter" ||
                                event.key === " "
                            ) {
                                event.preventDefault();
                                onClose();
                            }
                        }}
                        style={{
                            width: "36px",
                            height: "36px",
                            flexShrink: 0,
                            borderRadius: "50%",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            cursor: "pointer",
                            color: "#fff",

                            background:
                                `linear-gradient(180deg, ${OMNISCAN_BLUE} 0%, rgba(${OMNISCAN_BLUE_RGB},0.72) 100%)`,

                            border:
                                "1px solid rgba(255,255,255,0.20)",

                            boxShadow:
                                `0 5px 16px rgba(${OMNISCAN_BLUE_RGB},0.25)`,

                            marginRight: "14px",
                            transition: "background 0.2s ease"
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faChevronRight}
                        />
                    </div>
                )}

                <div
                    style={{
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        letterSpacing: "0.15px",
                        textShadow:
                            "0 1px 3px rgba(0,0,0,0.25)"
                    }}
                >
                    {title}
                </div>
            </div>

            {/* DRAWER CONTENT */}
            <div
                style={{
                    flex: 1,
                    minHeight: 0,
                    overflow: "hidden"
                }}
            >
                {children}
            </div>
        </div>
    );
}
